var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOwlUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.002 512.002",
    style: {
      enableBackground: "new 0 0 512.002 512.002"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBAF4B"
    },
    d: "M199.113,446.981c-4.492,0-8.127,3.639-8.127,8.127v1.298c0,4.194-3.27,7.75-7.452,8.099 l-71.936,5.996c-9.73,0.81-18.016,7.321-21.103,16.583l-4.738,14.214c-1.421,4.258,0.881,8.861,5.135,10.282 c0.857,0.286,1.722,0.421,2.571,0.421c3.405,0,6.571-2.155,7.706-5.559l4.738-14.214c1.032-3.087,3.794-5.258,7.04-5.528 l4.897-0.408v17.579c0,4.488,3.635,8.127,8.127,8.127s8.127-3.639,8.127-8.127v-18.933l9.249-0.771l7.425,22.276 c1.135,3.405,4.302,5.559,7.706,5.559c0.849,0,1.714-0.135,2.571-0.421c4.254-1.421,6.556-6.024,5.135-10.282l-6.174-18.522 l24.872-2.073c12.54-1.044,22.357-11.718,22.357-24.297v-1.298C207.239,450.62,203.605,446.981,199.113,446.981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBAF4B"
    },
    d: "M312.889,446.981c4.492,0,8.127,3.639,8.127,8.127v1.298c0,4.194,3.27,7.75,7.452,8.099 l71.936,5.996c9.73,0.81,18.016,7.321,21.103,16.583l4.738,14.214c1.421,4.258-0.881,8.861-5.135,10.282 c-0.857,0.286-1.722,0.421-2.571,0.421c-3.405,0-6.571-2.155-7.706-5.559l-4.738-14.214c-1.032-3.087-3.794-5.258-7.04-5.528 l-4.897-0.408v17.579c0,4.488-3.635,8.127-8.127,8.127s-8.127-3.639-8.127-8.127v-18.933l-9.249-0.771l-7.425,22.276 c-1.135,3.405-4.302,5.559-7.706,5.559c-0.849,0-1.714-0.135-2.571-0.421c-4.254-1.421-6.556-6.024-5.135-10.282l6.174-18.522 l-24.872-2.073c-12.54-1.044-22.357-11.718-22.357-24.297v-1.298C304.763,450.62,308.397,446.981,312.889,446.981z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#824D51"
    },
    cx: 256.001,
    cy: 280.38,
    rx: 195.05,
    ry: 199.11
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#C0826C"
    },
    cx: 256.001,
    cy: 288.51,
    rx: 130.03,
    ry: 174.73
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965A50"
    },
    d: "M475.428,138.158l-25.858,25.858c0.938-5.816,1.477-11.725,1.477-17.731 C451.047,65.494,363.722,0,256.001,0S60.955,65.494,60.955,146.285c0,6.006,0.539,11.915,1.477,17.731l-25.858-25.858 c0,0-29.395,73.487-32.28,122.629c-0.236,4.011,2.925,7.401,6.943,7.401h17.21v17.974c0,3.666,2.844,6.696,6.502,6.94 c18.976,1.268,76.662,3.09,135.306-15.415c-3.65-1.373,85.746-42.008,85.746-42.008s81.269,40.635,85.746,42.008 c58.644,18.504,116.33,16.682,135.306,15.415c3.658-0.244,6.502-3.275,6.502-6.94v-17.974h17.21c4.018,0,7.179-3.391,6.943-7.401 C504.823,211.645,475.428,138.158,475.428,138.158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AF6E5A"
    },
    d: "M448.873,62.685c27.642-15.503,37.435-37.153,40.905-50.528c1.328-5.121-3.629-9.484-8.621-7.732 c-62.354,21.888-163.89-9.678-214.844,76.628c-4.677,7.921-15.946,7.921-20.622,0C194.735-5.253,93.199,26.313,30.846,4.426 c-4.992-1.752-9.95,2.611-8.621,7.732c3.47,13.374,13.264,35.025,40.905,50.528c4.778,2.68,5.73,9.085,1.821,12.924 c-25.612,25.15-40.186,61.496-35.696,101.142c6.268,55.355,50.802,100.207,106.119,106.798 c51.342,6.117,97.277-19.731,120.628-60.241c23.352,40.51,69.287,66.358,120.628,60.241c55.317-6.591,99.851-51.443,106.119-106.798 c4.489-39.646-10.084-75.992-35.696-101.142C443.143,71.77,444.094,65.365,448.873,62.685z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EBAF4B"
    },
    cx: 150.351,
    cy: 162.54,
    r: 81.27
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFC850"
    },
    cx: 150.351,
    cy: 162.54,
    r: 56.888
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBAF4B"
    },
    d: "M261.328,286.492l16.15-43.066c1.769-4.717,0.617-10.032-2.945-13.594l-7.039-7.039 c-6.348-6.348-16.639-6.348-22.986,0l-7.039,7.039c-3.562,3.562-4.713,8.877-2.945,13.594l16.15,43.066 C252.52,291.414,259.482,291.414,261.328,286.492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B3F4E"
    },
    d: "M150.351,203.173L150.351,203.173c-17.954,0-32.508-14.554-32.508-32.508v-16.254 c0-17.953,14.554-32.508,32.508-32.508l0,0c17.953,0,32.508,14.554,32.508,32.508v16.254 C182.859,188.619,168.305,203.173,150.351,203.173z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 154.411,
    cy: 150.35,
    r: 12.19
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EBAF4B"
    },
    cx: 361.651,
    cy: 162.54,
    r: 81.27
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFC850"
    },
    cx: 361.651,
    cy: 162.54,
    r: 56.888
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B3F4E"
    },
    d: "M361.651,203.173L361.651,203.173c-17.954,0-32.508-14.554-32.508-32.508v-16.254 c0-17.953,14.554-32.508,32.508-32.508l0,0c17.953,0,32.508,14.554,32.508,32.508v16.254 C394.159,188.619,379.604,203.173,361.651,203.173z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 365.711,
    cy: 150.35,
    r: 12.19
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwlUserIcon);
export default __webpack_public_path__ + "static/media/owl-user-icon.7327b0eb59d2b383454f3e962438944c.svg";
export { ForwardRef as ReactComponent };